import React from 'react';
import { useTranslate } from 'react-admin';

const MultilineComment = ({ text, ...rest }) => {
  const translate = useTranslate();
  return text ? <div style={{marginTop: '-0.2em', marginLeft: '1em', fontSize: '0.75rem', color: '#0000008a' }} dangerouslySetInnerHTML={{ __html: translate(text) }} /> :null;
};

export default MultilineComment; // decorate with redux-form's <Field>